import React, { useEffect, useMemo, useState } from "react";

import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import SelectQ from "../../../components/FormComponents/SelectQ/SelectQ";
import ErrorMessage from "../../../components/TableBionovaQ/ErrorMessage/ErrorMessage";
import InputQ from "../../../components/FormComponents/InputQ/InputQ";

import request from "../../../utils/request";

import styles from "./PackagesTypesForm.module.css";
import { getSession } from "../../../utils/sessionHandler";
import { Checkbox, FormControlLabel, withStyles } from "@material-ui/core";
import CheckBoxQ from "../../../components/FormComponents/CheckBoxQ/CheckBoxQ";
import { PackagesGenerator } from "../../../components/PackagesGenerator";

import Search from "../../../components/Search/Search";
import DDPackagesTypes from "../../../components/DDPackagesTypes/DDPackagesTypes.jsx";
import { toast } from "react-toastify";
import BarcodeReader from "react-barcode-reader";

const PackagesTypesForm = ({
  formData,
  handleFormData,
  handleClose,
  open,
  locale,
  t,
  getPackagesTypes,
  selectedSector,
  materialsType,
  materials,
  methods,
  modelData,
  defaultValue,
}) => {
  const [error, setError] = useState("");
  const [validate, setValidate] = useState(false);
  const [prefilledMethod, setPrefilledMethod] = useState(0);
  const [defaultMaterial, setDefaultMaterial] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const handleSelectedMaterials = (data) => setSelectedMaterials(data);
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const handleMaterials = (arr) => setFilteredMaterials(arr);
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const handleSelectedFilteredMaterials = (data) =>
    setSelectedFilteredMaterials(data);
  const [selectedFilteredMaterials, setSelectedFilteredMaterials] = useState(
    []
  );
  const handleSearchActive = (bool) => setSearchActive(bool);
  const [searchActive, setSearchActive] = useState(false);
  const [scanCode, setScanCode] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.methodId) {
      setValidate(true);
      return;
    } else setValidate(false);

    try {
      const newMaterials = selectedMaterials.map((material) => ({
        materialId: material.id,
        quantity: material.quantity || 1,
      }));

      const bodyRequest = {
        ...formData,
        materials: newMaterials,
      };

      if (formData.id) {
        await request().put("/api/PredefinedPackage", bodyRequest);
      } else {
        await request().post("/api/PredefinedPackage", bodyRequest);
      }
      handleClose();
      setError("");
      setValidate(false);
      getPackagesTypes();
    } catch (err) {
      setError(
        err.response?.data?.message || "Error al guardar el esterilizador."
      );
    }
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setSelectedValue(value);
    handleFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onClose = () => {
    handleClose();
    setError("");
    setValidate(false);
  };

  const resetState = (e) => {
    setPrefilledMethod("");
    setDefaultMaterial();
  };

  const changeDefault = (e) => {
    setDefaultMaterial(e?.materials);
    setPrefilledMethod(parseInt(e?.methodId) || 0);
  };

  const onHandleScan = async (data) => {
    const itemMaterial = materials.find((m) => m.serial === data);
    const materialCondition = selectedMaterials.find((m) => m.serial === data);

    if (itemMaterial) {
      setScanCode(data);

      if (materialCondition) {
        setSelectedMaterials(
          selectedMaterials.filter((m) => m.serial !== data)
        );
        toast.success(t("MaterialRemoved", locale) || "Material removed");
      } else {
        setSelectedMaterials([...selectedMaterials, itemMaterial]);
        toast.success(t("MaterialAdded", locale) || "Material added");
      }
    } else {
      toast.error(t("MaterialNotFound", locale) || "Material not found");
    }
  };
  useEffect(() => {
    if (formData.id && Array.isArray(formData.materials)) {
      const formattedMaterials = formData.materials.map((material) => ({
        ...material,
        name: material.material?.name || material.name,
        serial: material.material.serial,
        methodId: material.material.methodId,
        id: material.material.id,
      }));
      setSelectedMaterials(formattedMaterials);
    }
  }, [formData.id, formData.materials]);

  return (
    <ModalQ
      open={open}
      title={
        !formData.id
          ? t("NewPackageType", locale) || "New Package Type"
          : t("EditPackageType", locale) || "Edit Package Type"
      }
      handleClose={onClose}
    >
      {error && <ErrorMessage message={error} />}
      <BarcodeReader onScan={onHandleScan} />
      <div className={styles.container}>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth={"48%"}
            labelTop={true}
            label={t("TypeofPackages", locale) || "Type of Packages"}
            name="name"
            handleChange={handleInputChange}
            value={formData.name}
            required={true}
            validate={validate}
            leftMessage={true}
          />
          <SelectQ
            selectValue={formData.methodId}
            handleSelect={handleSelectChange}
            options={methods}
            name={"methodId"}
            label={t("SelectAMethod") || "Select a Method"}
            placeholder={t("SelectAMethod") || "Select a Method"}
            required={true}
            errorMessage={t("RequiredField") || "This field is required"}
            validate={validate}
            containerWidth={"50%"}
            labelTop={true}
          />
        </div>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth="48%"
            labelTop={true}
            label={t("Description", locale) || "Description"}
            name="description"
            handleChange={handleInputChange}
            value={formData.description}
          />
          <InputQ
            containerWidth="48%"
            labelTop={true}
            label={t("ObservationSpan", locale) || "Observations"}
            name="observations"
            handleChange={handleInputChange}
            value={formData.observations}
          />
        </div>
        <div>
          {/* <PackagesGenerator
             dataType={materialsType}
             data={materials}
             defaultValue={formData.materials}
             selectedValue={selectedValue}
             callback = {(e) => {setNewMaterials(e)}}
            /> */}
          <DDPackagesTypes
            data={searchActive ? filteredMaterials : materials}
            selectedData={selectedMaterials}
            selectedFilteredData={
              searchActive ? selectedFilteredMaterials : selectedMaterials
            }
            handleSelectedData={handleSelectedMaterials}
            filter1={
              <Search
                data={materials}
                handleFilter={handleMaterials}
                placeholder={t("BlankEntry36") || "Search material..."}
                onHandleScan={onHandleScan}
                searchActive={handleSearchActive}
              />
            }
            filter2={
              <Search
                data={selectedMaterials}
                handleFilter={handleSelectedFilteredMaterials}
                placeholder={
                  t("BlankEntry37", locale) || "Search added material..."
                }
                searchActive={handleSearchActive}
                onHandleScan={onHandleScan}
              />
            }
            method={parseInt(formData.methodId)}
            leftColumnName={t("MaterialToInclude", locale)}
            rightColumnName={t("MaterialIncluded", locale)}
            category="Sterilization"
            onHandleScan={onHandleScan}
          />
        </div>

        <button
          className={`${styles.button} ${styles.confirmButton}`}
          onClick={(e) => handleSubmit(e)}
        >
          Confirm
        </button>
      </div>
    </ModalQ>
  );
};

export default PackagesTypesForm;
